module.exports = __webpack_public_path__ + "static/media/priceHistory.2a62e8a0.svg";